import { useGetOrderDetail } from "hooks/useOrders";
import { GetOrderDetailData } from "services/interface";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button, Typography } from "antd";
import styled from "@emotion/styled";
import { useAppSelector } from "../../store";
import { useGetTransportType, useMasterTransport } from "hooks/useMasterData";
import { formatDate, formatDateTime, formatDateTimeWithTime } from "utils/dateFormat";
import { bahttext } from "bahttext";
import { numberFormat } from "utils/nuberFormat";
import { useLoadBankList } from "hooks/useFactory";
import { getOrderSummary } from "utils/orderSummary";
import { isCanceledItemStatus } from "utils/orderStatus";
import dayjs from "dayjs";

const PrintDeliverynote = () => {
  const { id } = useParams<{ id: string }>();

  const ref = useRef(null);

  //const [totalPrice, setTotalPrice] = useState<number>(0);

//  const [vatPrice, setVatPrice] = useState<number>(0);

  //const [disCount, setDisCount] = useState<number>(0);

 // const [totalBeforeVat, setTotalBeforeVat] = useState<number>(0);

  //const [transportPrice, setTransportPrice] = useState<number>(0);

 // const [totalVipPrice, setTotalVipPrice] = useState<number>(0);

 // const [productTotal, setProductTotal] = useState<number>(0);

  const [data, setData] = useState<GetOrderDetailData>();

  const { data: transportTypeData } = useGetTransportType();

  const {
    data: dataTransportation,
    isLoading,
    refetch: refetchData,
  } = useMasterTransport({
    search: "",
  });

  // const [transportName, setTransportName] = useState<string>("");
  const currentYear = dayjs().year();
  const firstDayOfYear = dayjs(`${currentYear}-01-01`);
  const lastDayOfYear = dayjs(`${currentYear}-12-31`);

  const contact = useAppSelector((state) => state.auth.contact);
  const profile = useAppSelector((state) => state.auth.profile);

  const { data: dataBank, refetch: refetchBank } = useLoadBankList({
    start_date: dayjs(firstDayOfYear).locale("th").format("YYYY-MM-DD"),
    end_date: dayjs(lastDayOfYear).locale("th").format("YYYY-MM-DD"),
    status: "active",
    offset: 0,
    limit: 99,
  });

  const { mutate } = useGetOrderDetail();

  const renderRemark = (transport_type: string) => {
    switch (transport_type) {
      case "post_office":
        return data?.history_postal.postal_remark;
      case "taxi":
        return data?.history_postal.postal_remark;
      case "transport_bus":
        return data?.history_transport.remark_box;
      case "pick_up_yourself":
        return data?.history_transport_location.location_remark;
      default:
        return data?.history_transport.remark_box;
    }
  };

  /** สรุปยอดเงิน — ใช้ helper ตัวเดียวกับ ModalOrderDetail และใบสั่งซื้อ (รูป) ให้ตัวเลขตรงกันทุกจอ
   * ยอด vat อ่านจากฟิลด์ที่ backend คำนวณมาให้ (มี fallback เป็นสูตรเดิม 100/107 ใน helper) */
  const {
    totalTransportAmount,
    netPaidAmount,
    vatPercent,
    vatAmount,
    amountAfterVat,
    showVipDiscount,
    showFactoryDiscount,
  } = getOrderSummary(data);

  useEffect(() => {
    if (id) {
      mutate(
        {
          key_type: "order_id",
          group_by: "factory",
          items: [id ?? ""],
        },
        {
          onSuccess: async (data) => {
            const orderData = data.data[0];
            setData(orderData);

          //   const productTotal = orderData.items.reduce(
          //     (acc, item) =>
          //       acc +
          //       (item.sku_price) *
          //         item.sku_cnt,
          //     0
          //   );

          //   setProductTotal(productTotal);

          //   const discountAmount = orderData.discount_amount || 0;
          //   setDisCount(discountAmount);

          //   const productTotalVip = orderData.items.reduce(
          //     (acc, item) => acc + item.vip_price * item.sku_cnt,
          //     0
          //   );

          //   setTotalVipPrice(productTotalVip);

          //   const total =
          //     productTotal +
          //     orderData.transport_price -
          //     discountAmount -
          //     (orderData.order_is_vip ? productTotal - productTotalVip : 0);
          //   setTransportPrice(orderData.transport_price);
          // //  setTotalPrice(total);

          //   const totalBeforeVat = total * (100 / 107);
          //   setTotalBeforeVat(totalBeforeVat);

          //   const vat = total - totalBeforeVat;
          //   setVatPrice(vat);
          },
          onError: (error) => {
            console.log(error);
          },
        }
      );
    } else {
      console.log("id not found");
    }
  }, [id]);

  return (
    <div
      style={{
        backgroundColor: "rgb(99, 99, 99)",
        backgroundSize: "auto",
      }}
    >
      <ReactToPrint
        trigger={() => (
          <div
            style={{
              position: "fixed",
              top: "10px",
              right: "50px",
              zIndex: 1000,
            }}
          >
            <Button
              type="text"
              style={{ backgroundColor: "red", color: "white" }}
            >
              พิมพ์ใบส่งของ
            </Button>
          </div>
        )}
        content={() => ref?.current}
      />

      <div ref={ref}>
        <FramePdf>
          <MainPage>
            <Content>
              <PdfHeader>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "left",
                  }}
                >
                  <div style={{ marginRight: 10 }}>
                    <img
                      src={`${contact?.image_url}`}
                      alt="logo"
                      className="img"
                      width={"100%"}
                      height={40}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography.Text style={{ fontSize: 12, fontWeight: 400 }}>
                      {contact?.name}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      {contact?.address}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      โทร. {contact?.telephone_number}{" "}
                    </Typography.Text>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Typography.Text style={{ fontSize: 12, fontWeight: 400 }}>
                    ใบส่งของ
                  </Typography.Text>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: 3,
                      flexDirection: "column",
                    }}
                  >
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      ชื่อลูกค้า {data?.ref_name}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      ที่อยู่ {}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      เบอร์โทร {data?.address_telephone}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      การจัดส่ง{" "}
                      {
                        transportTypeData?.find(
                          (item) => item.key === data?.transport_type
                        )?.name
                      }{" "}
                    </Typography.Text>
                    {data?.transport_type === "pick_up_yourself" ? null : (
                      <>
                        <Typography.Text style={{ fontSize: 10 }}>
                          {" "}
                          ขนส่ง{" "}
                          {data?.transport_type === "post_office" ||
                          data?.transport_type === "taxi"
                            ? data.history_postal.brand_name
                            : data?.history_transport.transport_name}{" "}
                        </Typography.Text>
                        {data?.transport_type === "post_office" ||
                        data?.transport_type === "taxi" ? null : (
                          <Typography.Text style={{ fontSize: 10 }}>
                            จุดจอด{" "}
                            {data?.history_transport.history_parking_name}
                          </Typography.Text>
                        )}
                      </>
                    )}
                    {/* {data?.transport_type === "post_office" ? null : (
                      <Typography.Text style={{ fontSize: 10 }}>
                        {" "}
                        จำนวนลังที่สั่ง {data?.history_transport.order_box}{" "}
                      </Typography.Text>
                    )}
                    {data?.transport_type === "post_office" ? null : (
                      <Typography.Text style={{ fontSize: 10 }}>
                        {" "}
                        จำนวนลังที่ส่ง {
                          data?.history_transport.transport_box
                        }{" "}
                      </Typography.Text>
                    )} */}
                    {data?.history_transport.box_list.map((item, index) => {
                      return (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ flex: 3 }}>
                            <Typography.Text style={{ fontSize: 10 }}>
                              {`จำนวนกล่อง ${item.name}`}
                            </Typography.Text>
                          </div>
                          <div style={{ flex: 4 }}>
                            <Typography.Text
                              style={{ fontSize: 10, textAlign: "center" }}
                            >
                              {item.qty}
                            </Typography.Text>
                          </div>
                        </div>
                      );
                    })}

                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      ที่อยู่จัดส่ง {data?.address_text}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      หมายเหตุ {renderRemark(data?.transport_type ?? "")}
                    </Typography.Text>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flex: 2,
                      flexDirection: "column",
                    }}
                  >
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      หมายเลขคำสั่งซื้อ {data?.order_code}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      วันที่สั่งซื้อ{" "}
                      {formatDate(data?.items[0]?.order_date ?? "")}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      ช่องทางการสั่งซื้อ {data?.datasource}{" "}
                    </Typography.Text>
                    <Typography.Text style={{ fontSize: 10 }}>
                      {" "}
                      พนักงานขาย {profile?.user.name}{" "}
                    </Typography.Text>
                    {data?.payment_status === "pending" ? (
                      <Typography.Text style={{ fontSize: 10 }}>
                        {" "}
                        สถานะการชำระเงิน{" "}
                        <Typography.Text
                          style={{
                            fontSize: 10,
                            color: "red",
                            fontWeight: 400,
                          }}
                        >
                          ค้างชำระ{" "}
                        </Typography.Text>
                      </Typography.Text>
                    ) : null}
                    <div style={{ marginTop: 10 }}></div>
                    {data?.bank_payment &&
                      data?.bank_payment.map((item, index) => (
                        <React.Fragment key={index}>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            ประภทบัญชี{" "}
                            {
                              dataBank?.data.bank_list.find(
                                (bank) => bank.id === item.bank_id
                              )?.bank_type_name
                            }{" "}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            ธนาคาร {item.bank_name} {}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            เลขบัญชี {item.account_no} {}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            ชื่อบัญชี {item.account_name} {}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            เวลาโอน {formatDateTimeWithTime(item.payment_date ?? data?.items[0]?.order_date ?? "")} {}
                          </Typography.Text>
                          <Typography.Text style={{ fontSize: 10 }}>
                            {" "}
                            ยอดโอน {numberFormat(item.pay_amount)} {}
                          </Typography.Text>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              </PdfHeader>
              <PdfBody>
                <table style={{ width: "100%" }}>
                  <thead style={{ fontSize: 10 }}>
                    <tr
                      style={{
                        borderTop: "1px solid black",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <th
                        style={{
                          fontWeight: 400,
                          width: 50,
                          maxWidth: 50,
                          textAlign: "end",
                          padding: 2,
                          paddingRight: 10,
                        }}
                      >
                        ลำดับ
                      </th>
                      <th
                        style={{
                          fontWeight: 400,
                          width: 500,
                          textAlign: "start",
                          padding: 2,
                        }}
                      >
                        ชื่อสินค้า
                      </th>
                      <th
                        style={{
                          fontWeight: 400,
                          width: 100,
                          textAlign: "end",
                          padding: 2,
                        }}
                      >
                        จำนวน
                      </th>
                      <th
                        style={{
                          fontWeight: 400,
                          width: 100,
                          textAlign: "end",
                          padding: 2,
                        }}
                      >
                        ราคาต่อหน่วย
                      </th>
                      <th
                        style={{
                          fontWeight: 400,
                          width: 100,
                          textAlign: "end",
                          padding: 2,
                        }}
                      >
                        จำนวนเงิน
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items.map((item, index) => (
                      <>
                        <tr key={index} style={{ padding: 2, fontSize: 10 }}>
                          <td
                            style={{
                              width: 50,
                              maxWidth: 50,
                              textAlign: "end",
                              padding: 2,
                              paddingRight: 10,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              width: 500,
                              textAlign: "start",
                              padding: 2,
                            }}
                          >
                            {item.product_name}
                            {` ( ${item.sku_description} )`}
                            {isCanceledItemStatus(item.item_status) && (
                              <span style={{ color: "red" }}> (ยกเลิก)</span>
                            )}
                          </td>
                          <td
                            style={{ width: 100, textAlign: "end", padding: 2 }}
                          >
                            {item.sku_cnt}
                          </td>
                          <td
                            style={{ width: 100, textAlign: "end", padding: 2 }}
                          >
                            { data?.ref_source === 'retail' ? numberFormat(item.wholesale_price) : numberFormat(item.sku_price)}
                          </td>
                          <td
                            style={{ width: 100, textAlign: "end", padding: 2 }}
                          >
                            {numberFormat(
                              (data?.ref_source === 'retail' ? item.wholesale_price : item.sku_price) * item.sku_cnt
                            )}
                          </td>
                        </tr>
                        {
                        item.contact_comment_item &&
                        <tr>
                          <td
                            style={{
                              width: 50,
                              maxWidth: 50,
                              textAlign: "end",
                              padding: 2,
                              paddingRight: 10,
                            }}
                          >
                            
                          </td>
                          <td
                            style={{
                              width: 500,
                              textAlign: "start",
                              padding: 2,
                            }}
                          >
                           <p style={{ fontSize: 10, fontWeight: 400 }} >โน๊ตผู้ประกอบการ :   <span style={{ fontSize: 10, fontWeight:300,  whiteSpace: 'pre-line' }} >{item.contact_comment_item} </span> </p>
                          </td>
                        </tr>
                        }
                      </>
                    ))}
                  </tbody>
                </table>
              </PdfBody>
              <PdfFooter>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        border: "1px solid black",
                        padding: 5,
                        width: 200,
                        textAlign: "center",
                      }}
                    >
                      {bahttext(Number(netPaidAmount.toFixed(2)))}
                    </div>
                    <div style={{ flex: 1, borderTop: "1px solid black" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingLeft: 10,
                          height: "100%",
                          alignItems: "end",
                        }}
                      >
                        <Typography.Text style={{ fontSize: 10 }}>
                          ค่าส่ง{" "}
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 10, marginLeft: 10 }}
                        >
                          {numberFormat(totalTransportAmount)} บาท
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  {showVipDiscount ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          flex: 2,
                          padding: 5,
                          width: 200,
                          textAlign: "center",
                        }}
                      ></div>
                      <div style={{ flex: 1 }}>
                        {/* <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingLeft: 10,
                            height: "100%",
                            alignItems: "end",
                          }}
                        >
                          <Typography.Text style={{ fontSize: 10 }}>
                            ส่วนลดสิทธิพิเศษ{" "}
                          </Typography.Text>
                          <Typography.Text
                            style={{ fontSize: 10, marginLeft: 10 }}
                          >
                            {numberFormat(data?.extra_discount_amount ?? 0)} บาท
                          </Typography.Text>
                        </div> */}
                        <></>
                      </div>
                    </div>
                  ) : null}

                  {showFactoryDiscount ? (
                         <div
                         style={{
                           display: "flex",
                           flexDirection: "row",
                           width: "100%",
                         }}
                       >
                         <div
                           style={{
                             flex: 2,
                             padding: 5,
                             width: 200,
                             textAlign: "center",
                           }}
                         ></div>
                         <div style={{ flex: 1 }}>
                           <div
                             style={{
                               display: "flex",
                               flexDirection: "row",
                               justifyContent: "space-between",
                               paddingLeft: 10,
                               height: "100%",
                               alignItems: "end",
                             }}
                           >
                             <Typography.Text style={{ fontSize: 10 }}>
                               ส่วนลด{" "}
                             </Typography.Text>
                             <Typography.Text
                               style={{ fontSize: 10, marginLeft: 10 }}
                             >
                               {numberFormat(data?.discount_amount ?? 0)} บาท
                             </Typography.Text>
                           </div>
                         </div>
                       </div> 
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        padding: 5,
                        width: 200,
                        textAlign: "center",
                      }}
                    ></div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingLeft: 10,
                          height: "100%",
                          alignItems: "end",
                        }}
                      >
                        <Typography.Text style={{ fontSize: 10 }}>
                          รวมเป็นเงิน{" "}
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 10, marginLeft: 10 }}
                        >
                          {numberFormat(amountAfterVat)} บาท
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        padding: 5,
                        width: 200,
                        textAlign: "center",
                      }}
                    ></div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingLeft: 10,
                          height: "100%",
                          alignItems: "end",
                        }}
                      >
                        <Typography.Text style={{ fontSize: 10 }}>
                          VAT {vatPercent}%{" "}
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 10, marginLeft: 10 }}
                        >
                          {numberFormat(vatAmount)} บาท
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        padding: 5,
                        width: 200,
                        textAlign: "center",
                      }}
                    ></div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingLeft: 10,
                          height: "100%",
                          alignItems: "end",
                        }}
                      >
                        <Typography.Text style={{ fontSize: 10 }}>
                          รวมทั้งสิ้น{" "}
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 10, marginLeft: 10 }}
                        >
                          {numberFormat(netPaidAmount)} บาท
                        </Typography.Text>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "80%",
                      marginTop: 30,
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        borderTop: "1px solid black",
                        marginLeft: 20,
                        marginRight: 20,
                      }}
                    >
                      <Typography.Text style={{ fontSize: 10 }}>
                        ผู้รับของ
                      </Typography.Text>
                      <Typography.Text style={{ fontSize: 10 }}>
                        (ไดรับสินค้าครบแล้ว)
                      </Typography.Text>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        borderTop: "1px solid black",
                        marginLeft: 20,
                        marginRight: 20,
                      }}
                    >
                      <Typography.Text style={{ fontSize: 10 }}>
                        ผู้ส่งของ
                      </Typography.Text>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        borderTop: "1px solid black",
                        marginLeft: 20,
                        marginRight: 20,
                      }}
                    >
                      <Typography.Text style={{ fontSize: 10 }}>
                        ผู้อนุมัติ
                      </Typography.Text>
                    </div>
                  </div>
                </div>
              </PdfFooter>
            </Content>
          </MainPage>
        </FramePdf>
      </div>
    </div>
  );
};

export default PrintDeliverynote;

const FramePdf = styled.div`
  display: flex;
  position: relative;
  width: 100vw;
  height: auto;
  justify-content: center;
  padding-top: 1px;
  padding-bottom: 1px;
`;

const MainPage = styled.div`
  display: flex;
  width: 790px;
  height: 1096px;
  margin: auto;
  background-color: white;
  justify-content: center;
  padding: 30px 30px;
`;

const Content = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const PdfHeader = styled.div`
  width: 100%;
  height: auto;
`;

const PdfBody = styled.div`
  width: 100%;
  height: auto;
  margin-top: 20px;
`;

// fixed bottom
const PdfFooter = styled.div`
  width: 100%;
  height: 120px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 10px;
  font-size: 10px;
  font-weight: 400;
  color: black;
  text-align: center;
  line-height: 1.5;
`;
